<script lang="ts">
  import { onMount } from 'svelte';
  
  let mapContainer: HTMLElement;
  let map: google.maps.Map;
  let infoWindow: google.maps.InfoWindow;
  let marker: google.maps.Marker;
  
  const center = {
    lat: 35.690705538338605,
    lng: 139.765743125431,
  };

  const containerStyle = {
    width: '100%',
    height: '450px',
  };

  onMount(async () => {
    const { Loader } = await import('@googlemaps/js-api-loader');
    const loader = new Loader({
      apiKey: import.meta.env.VITE_GOOGLE_MAPS_API_KEY || ''
    });

    await loader.load();
    
    map = new google.maps.Map(mapContainer, {
      center,
      zoom: 17,
    });

    marker = new google.maps.Marker({
      position: center,
      map,
    });

    const size = new google.maps.Size(0, -45);

    infoWindow = new google.maps.InfoWindow({
      position: center,
      pixelOffset: size,
      disableAutoPan: true,
      content: `<div class="map_info map_info-short">
        <img src="./img/sptr-logo.svg" alt="スパトレ株式会社" />
      </div>`
    });

    infoWindow.open(map);
  });

  function handleKeyDown(event: KeyboardEvent) {
    if (event.key === 'Enter' || event.key === ' ') {
      event.preventDefault();
      map?.panTo(center);
    }
  }
</script>

<div class="map-container">
  <div
    bind:this={mapContainer}
    style="width: {containerStyle.width}; height: {containerStyle.height};"
    role="region"
    aria-label="Google Maps showing Spartan English training academy location"
  ></div>
  <button
    class="map-control"
    aria-label="Center map on Spartan English training academy"
    on:keydown={handleKeyDown}
  >Center Map</button>
</div>

<style>
  .map-container {
    position: relative;
  }
  .map-control {
    position: absolute;
    bottom: 10px;
    right: 10px;
    padding: 8px 16px;
    background: white;
    border: 1px solid #ccc;
    border-radius: 4px;
    z-index: 1;
  }
  :global(.map_info) {
    padding: 10px;
    text-align: center;
  }
  :global(.map_info img) {
    max-width: 150px;
    height: auto;
  }
</style>
